import get from 'lodash.get';
import { isValueDef } from '../typeGuards/ChannelDef';
export default function createGetterFromChannelDef(definition) {
  if (isValueDef(definition)) {
    return () => definition.value;
  }

  if (typeof definition.field !== 'undefined') {
    return x => get(x, definition.field);
  }

  return () => undefined;
}